import { UserRole, CurriculumAcma } from '@insync-students-constants/index';
export interface EntityBase {
  name: string;
  id: string;
}
export class User {
  id: string;
  firstName: string;
  lastName: string;
  roles: string[];
  avatar: string;
  schools: EntityBase[];
  district: EntityBase;
  licenses: EntityBase[];
  curriculums: Array<Partial<{
    id: string;
    gradeId: string;
  }>>;
  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }
  get isStudent() {
    return this.roles && this.roles.includes(UserRole.Student);
  }
  get isTeacher() {
    return this.roles && this.roles.includes(UserRole.Teacher);
  }
  get isAuthor() {
    return this.roles && this.roles.includes(UserRole.Author);
  }
  get hasCurriculums() {
    return this.curriculums && this.curriculums.length > 0;
  }
  get hasWitAndWisdomOnly() {
    return this.hasCurriculums && this.curriculums.every(curriculum => curriculum.id === CurriculumAcma.WitAndWisdom);
  }
  get hasEurekaMathOnly() {
    return this.hasCurriculums && this.curriculums.every(curriculum => curriculum.id === CurriculumAcma.EurekaMath);
  }
  constructor(data: Partial<User> = {}) {
    Object.assign(this, data);
  }
}